import { render, staticRenderFns } from "./BaseModalSmall.vue?vue&type=template&id=5da67c25&scoped=true"
import script from "./BaseModalSmall.vue?vue&type=script&lang=js"
export * from "./BaseModalSmall.vue?vue&type=script&lang=js"
import style0 from "./BaseModalSmall.vue?vue&type=style&index=0&id=5da67c25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da67c25",
  null
  
)

export default component.exports